/**
 * @file download.ts
 * @description Сохранение полученного с API файла на диск (phase19.12 шаг 6).
 *
 * PDF печатных форм отдаётся авторизованным запросом с cookie, поэтому
 * открыть его простой ссылкой нельзя — скачиваем blob'ом и отдаём браузеру
 * временной ссылкой.
 */

/** Скачать blob под указанным именем. */
export function saveBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  // Освобождаем URL после того, как браузер забрал файл.
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
